var auth = require('../auth');

$.fn.ycTmplRender = function (globalOptions) {
    this.each(function () {
        var $self = $(this),
            $tmplEl = $self.next('script[type="text/x-template"]');
        $self.trigger('tmpl-rollback');

        var options = $.extend({
            template: $tmplEl.length ? $tmplEl : null
        }, globalOptions);
        var tmpl = options.template.html();
        tmpl = simpleEs6Compiler(tmpl, auth.member);
        $self.hide();
        var $tmpl = $(tmpl);
        options.template.after($tmpl);

        $self.data('tmpl', $tmpl).one('tmpl-rollback', function () {
            $self.show();
            $tmpl.remove();
        });
    });
};

function simpleEs6Compiler(str, variables) {
    var reEsTemplate = /(\n)|(')|\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var importsKeys = ['__quote', '__ln'];
    var importsValues = ['\'', '\n'];

    $.each(variables, function (key, value) {
        importsKeys.push(key);
        importsValues.push(value);
    });

    var source = str
        .replace(reEsTemplate, function (matched, ln, quote, exp) {
            if (ln) {
                return '\' + (__ln) + \'';
            }
            if (quote) {
                return '\' + (__quote) + \'';
            }
            if (exp) {
                return '\' + (' + exp +') + \'';
            }
        })
    ;
    source = 'return \'' + source + '\';';

    return Function(importsKeys, source)
        .apply(undefined, importsValues);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth/src/plugins/tmpl-renderer.js
// module id = 8
// module chunks = 1